import React from 'react';
import Container from '../../../containers/master/faculties/showFacultyContainer';

export default function () {
  return (
    <Container />
  );
}
